(() => {
  const escapeHtml = (value) =>
    String(value).replace(/[&<>"']/g, (char) => {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });

  const init = (dataEl) => {
    let cfg;
    try {
      cfg = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const badge = document.getElementById(cfg.badgeId);
    if (!badge) return;

    const delivery = escapeHtml(cfg.deliveryText || '');

    // Ampel: out (rot) < low (gelb) < in (grün)
    const stateFor = (variant) => {
      if (!variant || !variant.available) return 'out';
      if (variant.managed && variant.qty > 0 && variant.qty < cfg.threshold) return 'low';
      return 'in';
    };

    const buildHtml = (state, qty) => {
      const dot = '<span class="vq-stock-badge__dot vq-stock-badge__dot--' + state + '" aria-hidden="true"></span>';

      if (state === 'out') {
        return dot + '<span class="vq-stock-badge__inner"><strong>Derzeit nicht auf Lager</strong></span>';
      }

      const label =
        state === 'low'
          ? qty <= cfg.qtyThreshold
            ? '<strong>Nur noch ' + qty + ' Stück auf Lager</strong>'
            : '<strong>Nur noch wenige Stücke auf Lager</strong>'
          : '<strong>Auf Lager</strong>';

      return (
        dot +
        '<span class="vq-stock-badge__inner">' +
        label +
        '<span class="vq-stock-badge__sep" aria-hidden="true">·</span>' +
        '<span class="vq-stock-badge__delivery">' +
        delivery +
        '</span></span>'
      );
    };

    const update = (variantId) => {
      const variant = cfg.variants[String(variantId)];
      const state = stateFor(variant);
      badge.className = 'vq-stock-badge vq-stock-badge--' + state;
      badge.innerHTML = buildHtml(state, variant ? variant.qty : 0);
    };

    // Dawn publiziert den Variantenwechsel über pubsub, nicht über ein DOM-Event
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const data = event && event.data;
        if (!data || data.sectionId !== cfg.sectionId) return;
        if (!data.variant) {
          badge.className = 'vq-stock-badge vq-stock-badge--out';
          badge.innerHTML = buildHtml('out', 0);
          return;
        }
        update(data.variant.id);
      });
    }

    // Fallback für Sektionen, die stattdessen ein DOM-Event feuern
    document.addEventListener('variant:change', (e) => {
      const id = e.detail && e.detail.variant && e.detail.variant.id;
      if (id) update(id);
    });
  };

  document.querySelectorAll('script[id^="vq-stock-data-"]').forEach(init);
})();
